import { useEffect, useState } from "react";

import styled from "styled-components/macro";

import { AnimatePresence, motion } from "framer-motion";

export default function VerticalCarousel({ items, random }) {
  const [currentWord, setCurrentWord] = useState(items[0]);
  const [currentItem, setCurrentItem] = useState(
    <CarouselItem>{items[0]}</CarouselItem>
  );
  const [lastWords, setLastWords] = useState([items[0]]);

  useEffect(() => {
    const getRandomWord = () => {
      const word = items[Math.floor(Math.random() * items.length)];
      if (!lastWords.includes(word)) return word;
      else return getRandomWord();
    };
    const loop = setInterval(() => {
      if (random) {
        setCurrentWord(getRandomWord());
      } else {
        const index = items.indexOf(currentWord);
        setCurrentWord(items[index + 1 >= items.length ? 0 : index + 1]);
      }
    }, 3000);
    return () => clearInterval(loop);
  }, [currentWord, items, random, lastWords]);

  useEffect(() => {
    setCurrentItem(<CarouselItem>{currentWord}</CarouselItem>);
    if (!lastWords.includes(currentWord))
      setLastWords((prevLastWords) => [...prevLastWords, ...[currentWord]]);
    else if (lastWords.length >= items.length) setLastWords([]);
  }, [currentWord, lastWords, items]);

  return (
    <Carousel>
      <AnimatePresence initial={false} exitBeforeEnter={false}>
        <CarouselItem key={currentWord}>{currentItem}</CarouselItem>
      </AnimatePresence>
    </Carousel>
  );
}

const Carousel = styled.span`
  position: relative;
`;

const CarouselItem = ({ children }) => {
  return (
    <Item
      initial={{ opacity: 0, y: "-100%" }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: "100%" }}
    >
      {children}
    </Item>
  );
};

const Item = styled(motion.span)`
  position: absolute;
  white-space: nowrap;
`;
